import React from "react";

/* ─────────────────────────────────────────
   IMAGE IMPORTS
───────────────────────────────────────── */
import HeroBgImg      from "../../../asset/images/contact/contact-hero.webp";
import FormBgImg      from "../../../asset/images/contact/contact-form-bg.webp";
import BcSepIcon      from "../../../asset/images/news/breadcrumb-separator.svg";

/* Social icons */
import LinkedinIcon   from "../../../asset/images/contact/icon-linkedin.svg";
import YoutubeIcon    from "../../../asset/images/contact/icon-youtube.svg";

/* ─────────────────────────────────────────
   CSS
───────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .cp { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }
  .cp a { text-decoration: none; color: inherit; }
  .cp img { display: block; max-width: 100%; }

  /* ── Layout ── */
  .cp-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ HERO ══ */
  .cp-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .cp-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center; display: block;
  }
  .cp-hero-overlay {
    position: absolute; inset: 0;
    // background: rgba(0, 0, 0, 0.52);
  }
  .cp-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column;
    justify-content: center;
    padding: 0 102px 48px 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .cp-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 700; color: #fff;
    line-height: 1.2; margin-bottom: 12px;
  }
  .cp-hero-divider {
    width: 240px; height: 3px;
    background: #EB2019; border: none;
  }

  /* ══ BREADCRUMB ══ */
  .cp-breadcrumb { padding: 40px 0 80px 0; background: #fff; }
  .cp-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; gap: 0;
  }
  .cp-bc-item {
    font-size: 16px; font-weight: 500; color: #202020;
    transition: color .15s;
  }
  .cp-bc-item:hover { color: #EB2019; }
  .cp-bc-item.active { color: #202020; }
  .cp-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 10px; flex-shrink: 0;
  }
  .cp-bc-sep img { width: 24px; height: 24px; display: block; }

  /* ══ FORM SECTION ══ */
  .cp-sec-form {
    position: relative; width: 100%;
    min-height: 620px; overflow: hidden;
    display: flex; align-items: center;
  }
  .cp-form-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center; display: block;
  }
  .cp-form-overlay {
    position: absolute; inset: 0;

  }
  .cp-form-inner {
    position: relative; z-index: 2;
    max-width: 1600px; margin: 0 auto; padding: 60px 102px;
    width: 100%;
  }
  .cp-form-card {
    background: #fff;
    border-radius: 12px;
    padding: 30px;
    max-width: 513px;
    width: 100%;
  }
  .cp-form-title {
    font-size: 20px; font-weight: 600;
    color: #202020; margin-bottom: 14px;
  }
  .cp-form-subtitle {
    font-size: 14px; color: #000000;
    line-height: 160%; margin-bottom: 24px;
  }
  .cp-form-row {
    display: grid; grid-template-columns: 1fr 1fr; gap: 15px;
    margin-bottom: 12px;
  }
  .cp-form-field {
    width: 100%; margin-bottom: 12px;
  }
  .cp-input {
    width: 100%; padding: 12px 14px;
    background: #F2F5FA; border: none; border-radius: 6px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px; color: #74767A;
    outline: none; transition: box-shadow .2s;
  }
  .cp-input::placeholder { color: #74767A; }
  .cp-input:focus { box-shadow: 0 0 0 2px rgba(235,32,25,.25); }
  .cp-textarea {
    width: 100%; padding: 12px 14px;
    background: #F0F4F8; border: none; border-radius: 6px;
    font-family: 'Poppins', sans-serif;
    font-size: 13px; color: #202020;
    outline: none; resize: vertical;
    min-height: 110px; transition: box-shadow .2s;
    margin-bottom: 20px;
  }
  .cp-textarea::placeholder { color: #999; }
  .cp-textarea:focus { box-shadow: 0 0 0 2px rgba(235,32,25,.25); }
  .cp-submit-btn {
    width: 100%; padding: 16px;
    background: #EB2019; color: #fff;
    border: none; border-radius: 6px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600;
    cursor: pointer; transition: background .2s;
  }
  .cp-submit-btn:hover { background: #c0150e; }

  /* ══ INFO CARDS ══ */
  .cp-sec-info { padding: 80px 0px 120px 0px; background: #fff; }
  .cp-info-grid {
    display: grid; grid-template-columns: repeat(3, 1fr); gap: 30px;
  }
  .cp-info-card {
    border-radius: 10px;
    padding: 40px 30px; text-align: center;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
  }
  .cp-info-icon-wrap {
    width: 84px; height: 84px;
    background: #F2F5FA; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto 34px auto;
  }
  .cp-info-title {
    font-size: 24px; font-weight: 600;
    color: #202020; margin-bottom: 14px;
  }
  .cp-info-body {
    font-size: 16px; color: #202020;
    line-height: 160%;
  }

  /* ══ STAY CONNECTED ══ */
  .cp-sec-social { padding: 0 0 120px 0; background: #fff; }
  .cp-social-title {
    font-size: 24px; font-weight: 600;
    color: #202020; text-align: center; margin-bottom: 24px;
  }
  .cp-social-icons {
    display: flex; align-items: center;
    justify-content: center; gap: 34px;
  }
  .cp-social-btn {
    width: 54px; height: 54px;
    background: #FFE6E5; border-radius: 10px;
    display: flex; align-items: center; justify-content: center;
    transition: background .2s, transform .2s;
  }
//   .cp-social-btn:hover { background: #c0150e; transform: translateY(-2px); }
  .cp-social-icon {
    width: 28px; height: 28px;
    object-fit: contain; display: block;
  }

  /* ══ MAP ══ */
  .cp-sec-map { width: 100%; height: 440px; overflow: hidden; }
  .cp-map-iframe {
    width: 100%; height: 100%; border: 0; display: block;
  }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .cp-inner              { padding: 0 32px; }
    .cp-hero               { height: 350px; }
    .cp-hero-content       { padding: 0 32px 40px 32px; }
    .cp-hero-title         { font-size: 30px; }
    .cp-breadcrumb { padding: 30px 0 40px 0;}
    .cp-breadcrumb-inner   { padding: 0 32px; }
    .cp-form-inner         { padding: 40px 32px; }
    .cp-info-grid          { grid-template-columns: 1fr 1fr; gap: 20px; }
    .cp-sec-info           { padding: 40px 0; }
.cp-sec-social { padding: 0px 0 40px 0px; }
    .cp-sec-map            { height: 320px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .cp-inner              { padding: 0 16px; }
    .cp-hero               { height: 400px; }
    .cp-breadcrumb { padding: 30px 0 30px 0;}
    .cp-hero-content       { padding: 0 16px 32px 16px; }
    .cp-hero-title         { font-size: 24px; margin-bottom:15px;}
    .cp-breadcrumb-inner   { padding: 0 16px; }
    cp-bc-item { font-size: 14px; }
    .cp-form-inner { 
        padding: 53px 16px;
    }
    .cp-form-card          { padding: 28px 20px; }
    .cp-form-row           { grid-template-columns: 1fr 1fr; gap: 14px; margin-bottom: 14px;}
    .cp-input { padding: 12px 10px;}
    .cp-textarea { font-size: 14px; }
        .cp-sec-info {         padding: 30px 0;}
      .cp-info-icon-wrap { width:84px; height:84px;} 
      .cp-info-title { font-size: 20px; margin-bottom:20px; }
      .cp-info-card {     padding: 22px 21px 78px 21px;}
      .cp-info-body { font-size: 14px;}
      .cp-social-title { font-size: 20px;  margin-bottom:24px; }
      .cp-social-icons { gap:34px;}
      .cp-social-btn { width:84px; height:84px;}
      .cp-sec-social {     padding: 0 0 30px 0;}
       
    .cp-info-grid          { grid-template-columns: 1fr; }
    .cp-sec-map            { height: 260px; }
    .cp-hero-divider       { width: 141px; }
  }
`;

/* ─────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────── */
export default function ContactUs() {
  return (
    <div className="cp">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="cp-hero">
        <img src={HeroBgImg} alt="Contact Us Hero" className="cp-hero-bg" />
        <div className="cp-hero-overlay" />
        <div className="cp-hero-content">
          <h1 className="cp-hero-title">Contact Us</h1>
          <hr className="cp-hero-divider" />
        </div>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="cp-breadcrumb" aria-label="Breadcrumb">
        <div className="cp-breadcrumb-inner">
          <a href="/" className="cp-bc-item">Home</a>
          <span className="cp-bc-sep">
            <img src={BcSepIcon} alt="" />
          </span>
          <span className="cp-bc-item active">Contact Us</span>
        </div>
      </nav>

      {/* ══ 3. FORM SECTION ══ */}
      <section className="cp-sec-form">
        <img src={FormBgImg} alt="Office background" className="cp-form-bg" />
        <div className="cp-form-overlay" />
        <div className="cp-form-inner">
          <div className="cp-form-card">
            <h2 className="cp-form-title">Get In Touch</h2>
            <p className="cp-form-subtitle">
              Don't Hesitate To Contact Us For More Information About The Product Or Services.
            </p>

            {/* Name | Company */}
            <div className="cp-form-row">
              <input className="cp-input" type="text" placeholder="Name" />
              <input className="cp-input" type="text" placeholder="Company" />
            </div>

            {/* Phone | Email */}
            <div className="cp-form-row">
              <input className="cp-input" type="tel" placeholder="Phone Number" />
              <input className="cp-input" type="email" placeholder="Email" />
            </div>

            {/* Subject */}
            <div className="cp-form-field">
              <input className="cp-input" type="text" placeholder="Subject" />
            </div>

            {/* Message */}
            <textarea className="cp-textarea" placeholder="Message" rows={4} />

            {/* Submit */}
            <button className="cp-submit-btn" type="button">Submit</button>
          </div>
        </div>
      </section>

      {/* ══ 4. INFO CARDS ══ */}
      <section className="cp-sec-info">
        <div className="cp-inner">
          <div className="cp-info-grid">

            {/* Headquarter */}
            <div className="cp-info-card">
              <div className="cp-info-icon-wrap">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#EB2019"/>
                  <circle cx="12" cy="9" r="2.5" fill="#fff"/>
                </svg>
              </div>
              <h3 className="cp-info-title">Headquarter</h3>
              <p className="cp-info-body">
                Ador Warrior City Campus, Plot No. 51, D-II Block,<br />
                Ramnagar, MIDC, Chinchwad, Pune,<br />
                Maharashtra 411019
              </p>
            </div>

            {/* Email Us */}
            <div className="cp-info-card">
              <div className="cp-info-icon-wrap">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#EB2019"/>
                  <circle cx="12" cy="9" r="2.5" fill="#fff"/>
                </svg>
              </div>
              <h3 className="cp-info-title">Email Us</h3>
              <p className="cp-info-body">info@adorpower.Com</p>
            </div>

            {/* Call Us */}
            <div className="cp-info-card">
              <div className="cp-info-icon-wrap">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#EB2019"/>
                  <circle cx="12" cy="9" r="2.5" fill="#fff"/>
                </svg>
              </div>
              <h3 className="cp-info-title">Call Us</h3>
              <p className="cp-info-body">+91 9763729538</p>
            </div>

          </div>
        </div>
      </section>

      {/* ══ 5. STAY CONNECTED ══ */}
      <section className="cp-sec-social">
        <div className="cp-inner">
          <h2 className="cp-social-title">Stay Connected With Us</h2>
          <div className="cp-social-icons">

            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/company/139191/"
              className="cp-social-btn"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <img src={LinkedinIcon} alt="LinkedIn" className="cp-social-icon" />
            </a>

            {/* YouTube */}
            <a
              href="https://www.youtube.com/@adorIndia"
              className="cp-social-btn"
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
            >
              <img src={YoutubeIcon} alt="YouTube" className="cp-social-icon" />
            </a>

          </div>
        </div>
      </section>

      {/* ══ 6. GOOGLE MAP ══ */}
      <section className="cp-sec-map">
        <iframe
          className="cp-map-iframe"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3780.9!2d73.8!3d18.65!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b9e760d4d4a3%3A0x5e9e7e4e4e4e4e4e!2sAdor%20Powertron%20Ltd.%2C%20Chinchwad%2C%20Pune!5e0!3m2!1sen!2sin!4v1"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Ador Powertron Location"
        />
      </section>

    </div>
  );
}